export default __webpack_public_path__ + "static/js/react-dom.static.js";